/**
 * City Images Configuration
 * 
 * Comprehensive mapping of US cities to their representative Unsplash photos.
 * Covers all 50 states with multiple cities for popular tourism destinations.
 * 
 * Organization: By state (alphabetical), then cities within each state
 */

export const CITY_IMAGES = {
  // ═══════════════════════════════════════════════════════════════════════════
  // ALABAMA
  // ═══════════════════════════════════════════════════════════════════════════
  'Birmingham': 'https://images.unsplash.com/photo-1578301978693-85fa9c0320b9?w=400&h=300&fit=crop',
  'Mobile': 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=400&h=300&fit=crop',
  'Gulf Shores': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // ALASKA
  // ═══════════════════════════════════════════════════════════════════════════
  'Anchorage': 'https://images.unsplash.com/photo-1503095396549-807759245b35?w=400&h=300&fit=crop',
  'Juneau': 'https://images.unsplash.com/photo-1531366936337-7c912a4589a7?w=400&h=300&fit=crop',
  'Fairbanks': 'https://images.unsplash.com/photo-1489493887464-892be6d1daae?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // ARIZONA
  // ═══════════════════════════════════════════════════════════════════════════
  'Phoenix': 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
  'Scottsdale': 'https://images.unsplash.com/photo-1469854523086-cc02fe5d8800?w=400&h=300&fit=crop',
  'Sedona': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',
  'Tucson': 'https://images.unsplash.com/photo-1538689621163-f5be4195d4e7?w=400&h=300&fit=crop',
  'Grand Canyon': 'https://images.unsplash.com/photo-1474044159687-1ee9f3a51722?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // ARKANSAS
  // ═══════════════════════════════════════════════════════════════════════════
  'Little Rock': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Hot Springs': 'https://images.unsplash.com/photo-1544551763-46a013bb70d5?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // CALIFORNIA
  // ═══════════════════════════════════════════════════════════════════════════
  'Los Angeles': 'https://images.unsplash.com/photo-1534190760961-74e8c1c5c3da?w=400&h=300&fit=crop',
  'San Francisco': 'https://images.unsplash.com/photo-1501594907352-04cda38ebc29?w=400&h=300&fit=crop',
  'San Diego': 'https://images.unsplash.com/photo-1538964173425-93405528cf72?w=400&h=300&fit=crop',
  'Santa Monica': 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=400&h=300&fit=crop',
  'Newport Beach': 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=400&h=300&fit=crop',
  'Sacramento': 'https://images.unsplash.com/photo-1590736704728-f4730bb30770?w=400&h=300&fit=crop',
  'Lake Tahoe': 'https://images.unsplash.com/photo-1501908734255-16579c18c25f?w=400&h=300&fit=crop',
  'Napa': 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=400&h=300&fit=crop',
  'Napa Valley': 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=400&h=300&fit=crop',
  'Palm Springs': 'https://images.unsplash.com/photo-1449034446853-66c86144b0ad?w=400&h=300&fit=crop',
  'Monterey': 'https://images.unsplash.com/photo-1528158230911-e614cdde7d10?w=400&h=300&fit=crop',
  'Santa Barbara': 'https://images.unsplash.com/photo-1527549993850-de5d8a27f348?w=400&h=300&fit=crop',
  'Long Beach': 'https://images.unsplash.com/photo-1517760444937-f6397edcbbcd?w=400&h=300&fit=crop',
  'Malibu': 'https://images.unsplash.com/photo-1534430480872-3498386e7856?w=400&h=300&fit=crop',
  'Laguna Beach': 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // COLORADO
  // ═══════════════════════════════════════════════════════════════════════════
  'Denver': 'https://images.unsplash.com/photo-1546156929-a4c0ac411f47?w=400&h=300&fit=crop',
  'Boulder': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Aspen': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',
  'Vail': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',
  'Colorado Springs': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // CONNECTICUT
  // ═══════════════════════════════════════════════════════════════════════════
  'Hartford': 'https://images.unsplash.com/photo-1571939228382-b2f2b585ce15?w=400&h=300&fit=crop',
  'New Haven': 'https://images.unsplash.com/photo-1571939228382-b2f2b585ce15?w=400&h=300&fit=crop',
  'Mystic': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // DELAWARE
  // ═══════════════════════════════════════════════════════════════════════════
  'Wilmington': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
  'Rehoboth Beach': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // FLORIDA
  // ═══════════════════════════════════════════════════════════════════════════
  'Miami': 'https://images.unsplash.com/photo-1533106497176-45ae19e68ba2?w=400&h=300&fit=crop',
  'Miami Beach': 'https://images.unsplash.com/photo-1535498730771-e735b998cd64?w=400&h=300&fit=crop',
  'Fort Lauderdale': 'https://images.unsplash.com/photo-1605723517503-3cadb5818a0c?w=400&h=300&fit=crop',
  'Tampa': 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=400&h=300&fit=crop',
  'Key West': 'https://images.unsplash.com/photo-1580256081112-e49377338b7f?w=400&h=300&fit=crop',
  'Orlando': 'https://images.unsplash.com/photo-1575089776834-8be34c2a1b8b?w=400&h=300&fit=crop',
  'Naples': 'https://images.unsplash.com/photo-1590523277543-a94d2e4eb00b?w=400&h=300&fit=crop',
  'Clearwater': 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=400&h=300&fit=crop',
  'Jacksonville': 'https://images.unsplash.com/photo-1564078516393-cf04bd966897?w=400&h=300&fit=crop',
  'St. Augustine': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
  'Destin': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Sarasota': 'https://images.unsplash.com/photo-1519046904884-53103b34b206?w=400&h=300&fit=crop',
  'Panama City Beach': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // GEORGIA
  // ═══════════════════════════════════════════════════════════════════════════
  'Atlanta': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
  'Savannah': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
  'Augusta': 'https://images.unsplash.com/photo-1535131749006-b7f58c99034b?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // HAWAII
  // ═══════════════════════════════════════════════════════════════════════════
  'Honolulu': 'https://images.unsplash.com/photo-1507876466758-bc54f384809c?w=400&h=300&fit=crop',
  'Maui': 'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=400&h=300&fit=crop',
  'Kauai': 'https://images.unsplash.com/photo-1505852679233-d9fd70aff56d?w=400&h=300&fit=crop',
  'Waikiki': 'https://images.unsplash.com/photo-1507876466758-bc54f384809c?w=400&h=300&fit=crop',
  'Kona': 'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=400&h=300&fit=crop',
  'Hilo': 'https://images.unsplash.com/photo-1542259009477-d625272157b7?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // IDAHO
  // ═══════════════════════════════════════════════════════════════════════════
  'Boise': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Sun Valley': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',
  'Coeur d\'Alene': 'https://images.unsplash.com/photo-1501908734255-16579c18c25f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // ILLINOIS
  // ═══════════════════════════════════════════════════════════════════════════
  'Chicago': 'https://images.unsplash.com/photo-1494522855154-9297ac14b55f?w=400&h=300&fit=crop',
  'Springfield': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // INDIANA
  // ═══════════════════════════════════════════════════════════════════════════
  'Indianapolis': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // IOWA
  // ═══════════════════════════════════════════════════════════════════════════
  'Des Moines': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // KANSAS
  // ═══════════════════════════════════════════════════════════════════════════
  'Kansas City': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Wichita': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // KENTUCKY
  // ═══════════════════════════════════════════════════════════════════════════
  'Louisville': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Lexington': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // LOUISIANA
  // ═══════════════════════════════════════════════════════════════════════════
  'New Orleans': 'https://images.unsplash.com/photo-1568402102990-bc541580b59f?w=400&h=300&fit=crop',
  'Baton Rouge': 'https://images.unsplash.com/photo-1568402102990-bc541580b59f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MAINE
  // ═══════════════════════════════════════════════════════════════════════════
  'Portland': 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=400&h=300&fit=crop',
  'Bar Harbor': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'Acadia': 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MARYLAND
  // ═══════════════════════════════════════════════════════════════════════════
  'Baltimore': 'https://images.unsplash.com/photo-1569761316261-9a8696fa2ca3?w=400&h=300&fit=crop',
  'Annapolis': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'Ocean City': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MASSACHUSETTS
  // ═══════════════════════════════════════════════════════════════════════════
  'Boston': 'https://images.unsplash.com/photo-1501979376754-1d09a162d432?w=400&h=300&fit=crop',
  'Cape Cod': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'Martha\'s Vineyard': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'Nantucket': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'Cambridge': 'https://images.unsplash.com/photo-1501979376754-1d09a162d432?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MICHIGAN
  // ═══════════════════════════════════════════════════════════════════════════
  'Detroit': 'https://images.unsplash.com/photo-1555353540-64580f51c258?w=400&h=300&fit=crop',
  'Grand Rapids': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Traverse City': 'https://images.unsplash.com/photo-1501908734255-16579c18c25f?w=400&h=300&fit=crop',
  'Mackinac Island': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MINNESOTA
  // ═══════════════════════════════════════════════════════════════════════════
  'Minneapolis': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'St. Paul': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Duluth': 'https://images.unsplash.com/photo-1501908734255-16579c18c25f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MISSISSIPPI
  // ═══════════════════════════════════════════════════════════════════════════
  'Jackson': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Biloxi': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MISSOURI
  // ═══════════════════════════════════════════════════════════════════════════
  'St. Louis': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Branson': 'https://images.unsplash.com/photo-1501908734255-16579c18c25f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // MONTANA
  // ═══════════════════════════════════════════════════════════════════════════
  'Bozeman': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Missoula': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Glacier': 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&h=300&fit=crop',
  'Big Sky': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEBRASKA
  // ═══════════════════════════════════════════════════════════════════════════
  'Omaha': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Lincoln': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEVADA
  // ═══════════════════════════════════════════════════════════════════════════
  'Las Vegas': 'https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?w=400&h=300&fit=crop',
  'Reno': 'https://images.unsplash.com/photo-1581351721010-8cf859cb14a4?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEW HAMPSHIRE
  // ═══════════════════════════════════════════════════════════════════════════
  'Manchester': 'https://images.unsplash.com/photo-1571939228382-b2f2b585ce15?w=400&h=300&fit=crop',
  'Portsmouth': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'White Mountains': 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEW JERSEY
  // ═══════════════════════════════════════════════════════════════════════════
  'Atlantic City': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Jersey City': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop',
  'Cape May': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEW MEXICO
  // ═══════════════════════════════════════════════════════════════════════════
  'Albuquerque': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',
  'Santa Fe': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',
  'Taos': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NEW YORK
  // ═══════════════════════════════════════════════════════════════════════════
  'New York': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop',
  'New York City': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop',
  'NYC': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop',
  'Manhattan': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop',
  'Brooklyn': 'https://images.unsplash.com/photo-1496442226666-8d4d0e62e6e9?w=400&h=300&fit=crop',
  'Buffalo': 'https://images.unsplash.com/photo-1571939228382-b2f2b585ce15?w=400&h=300&fit=crop',
  'The Hamptons': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',
  'Lake Placid': 'https://images.unsplash.com/photo-1501908734255-16579c18c25f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NORTH CAROLINA
  // ═══════════════════════════════════════════════════════════════════════════
  'Charlotte': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Asheville': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Raleigh': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Outer Banks': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Wilmington': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // NORTH DAKOTA
  // ═══════════════════════════════════════════════════════════════════════════
  'Fargo': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // OHIO
  // ═══════════════════════════════════════════════════════════════════════════
  'Columbus': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Cleveland': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Cincinnati': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // OKLAHOMA
  // ═══════════════════════════════════════════════════════════════════════════
  'Oklahoma City': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Tulsa': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // OREGON
  // ═══════════════════════════════════════════════════════════════════════════
  'Portland': 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=400&h=300&fit=crop',
  'Eugene': 'https://images.unsplash.com/photo-1507699622108-4be3abd695ad?w=400&h=300&fit=crop',
  'Bend': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Cannon Beach': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // PENNSYLVANIA
  // ═══════════════════════════════════════════════════════════════════════════
  'Philadelphia': 'https://images.unsplash.com/photo-1569761316261-9a8696fa2ca3?w=400&h=300&fit=crop',
  'Pittsburgh': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // RHODE ISLAND
  // ═══════════════════════════════════════════════════════════════════════════
  'Providence': 'https://images.unsplash.com/photo-1571939228382-b2f2b585ce15?w=400&h=300&fit=crop',
  'Newport': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // SOUTH CAROLINA
  // ═══════════════════════════════════════════════════════════════════════════
  'Charleston': 'https://images.unsplash.com/photo-1577717903315-1691ae25ab3f?w=400&h=300&fit=crop',
  'Myrtle Beach': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Hilton Head': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // SOUTH DAKOTA
  // ═══════════════════════════════════════════════════════════════════════════
  'Sioux Falls': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Rapid City': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Mount Rushmore': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // TENNESSEE
  // ═══════════════════════════════════════════════════════════════════════════
  'Nashville': 'https://images.unsplash.com/photo-1567706054688-7e39ca43d99a?w=400&h=300&fit=crop',
  'Memphis': 'https://images.unsplash.com/photo-1567706054688-7e39ca43d99a?w=400&h=300&fit=crop',
  'Gatlinburg': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Pigeon Forge': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // TEXAS
  // ═══════════════════════════════════════════════════════════════════════════
  'Austin': 'https://images.unsplash.com/photo-1531218150217-54595bc2b934?w=400&h=300&fit=crop',
  'Dallas': 'https://images.unsplash.com/photo-1545194445-dddb8f4487c6?w=400&h=300&fit=crop',
  'Houston': 'https://images.pexels.com/photos/9556433/pexels-photo-9556433.jpeg?auto=compress&cs=tinysrgb&w=400&h=300&fit=crop',
  'San Antonio': 'https://images.unsplash.com/photo-1558618666-fcd25c85cd64?w=400&h=300&fit=crop',
  'Fort Worth': 'https://images.unsplash.com/photo-1531969579561-c97a32cf0549?w=400&h=300&fit=crop',
  'El Paso': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',
  'Galveston': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Galvenston': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop', // Common misspelling
  'South Padre Island': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Fredericksburg': 'https://images.unsplash.com/photo-1506377247377-2a5b3b417ebb?w=400&h=300&fit=crop',
  'Corpus Christi': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // UTAH
  // ═══════════════════════════════════════════════════════════════════════════
  'Salt Lake City': 'https://images.unsplash.com/photo-1617245485328-8f34ee4e5e32?w=400&h=300&fit=crop',
  'Park City': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',
  'Moab': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',
  'St. George': 'https://images.unsplash.com/photo-1518098268026-4e89f1a2cd8e?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // VERMONT
  // ═══════════════════════════════════════════════════════════════════════════
  'Burlington': 'https://images.unsplash.com/photo-1571939228382-b2f2b585ce15?w=400&h=300&fit=crop',
  'Stowe': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // VIRGINIA
  // ═══════════════════════════════════════════════════════════════════════════
  'Virginia Beach': 'https://images.unsplash.com/photo-1507525428034-b723cf961d3e?w=400&h=300&fit=crop',
  'Richmond': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
  'Alexandria': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',
  'Williamsburg': 'https://images.unsplash.com/photo-1555396273-367ea4eb4db5?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // WASHINGTON
  // ═══════════════════════════════════════════════════════════════════════════
  'Seattle': 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=400&h=300&fit=crop',
  'Spokane': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',
  'Tacoma': 'https://images.unsplash.com/photo-1502175353174-a7a70e73b362?w=400&h=300&fit=crop',
  'Olympic': 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // WASHINGTON DC
  // ═══════════════════════════════════════════════════════════════════════════
  'Washington DC': 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=400&h=300&fit=crop',
  'Washington D.C.': 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=400&h=300&fit=crop',
  'Washington': 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=400&h=300&fit=crop',
  'DC': 'https://images.unsplash.com/photo-1501466044931-62695aada8e9?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // WEST VIRGINIA
  // ═══════════════════════════════════════════════════════════════════════════
  'Charleston': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // WISCONSIN
  // ═══════════════════════════════════════════════════════════════════════════
  'Milwaukee': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Madison': 'https://images.unsplash.com/photo-1572816703439-d8b34c4dc93f?w=400&h=300&fit=crop',
  'Door County': 'https://images.unsplash.com/photo-1499793983690-e29da59ef1c2?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // WYOMING
  // ═══════════════════════════════════════════════════════════════════════════
  'Jackson Hole': 'https://images.unsplash.com/photo-1551698618-1dfe5d97d256?w=400&h=300&fit=crop',
  'Yellowstone': 'https://images.unsplash.com/photo-1503614472-8c93d56e92ce?w=400&h=300&fit=crop',
  'Cheyenne': 'https://images.unsplash.com/photo-1558036117-15d82a90b9b1?w=400&h=300&fit=crop',

  // ═══════════════════════════════════════════════════════════════════════════
  // DEFAULT - Generic travel/coastal image
  // ═══════════════════════════════════════════════════════════════════════════
  'default': 'https://images.unsplash.com/photo-1476514525535-07fb3b4ae5f1?w=400&h=300&fit=crop'
};

/**
 * Get image URL for a city
 * @param {string} cityName - Name of the city
 * @returns {string} - Unsplash URL for the city image
 */
export const getCityImage = (cityName) => {
  if (!cityName) return CITY_IMAGES.default;
  
  // Try exact match first
  if (CITY_IMAGES[cityName]) {
    return CITY_IMAGES[cityName];
  }
  
  // Try case-insensitive match
  const lowerCityName = cityName.toLowerCase();
  const matchedKey = Object.keys(CITY_IMAGES).find(
    key => key.toLowerCase() === lowerCityName
  );
  
  return matchedKey ? CITY_IMAGES[matchedKey] : CITY_IMAGES.default;
};

export default CITY_IMAGES;
